import { useCallback, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ui/ScrollToTop";
import IntroReveal from "@/components/ui/IntroReveal";
import { IntroStateProvider } from "@/context/intro-state";

// Layout
import { Layout } from "@/components/layout/Layout";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";

function App() {
  const [showIntro, setShowIntro] = useState(true);
  const [allowPageAnimations, setAllowPageAnimations] = useState(false);

  const handleIntroSplitStart = useCallback(() => {
    setAllowPageAnimations(true);
  }, []);

  const handleIntroComplete = useCallback(() => {
    setShowIntro(false);
    setAllowPageAnimations(true);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("intro-pending", !allowPageAnimations);
    return () => document.body.classList.remove("intro-pending");
  }, [allowPageAnimations]);

  return (
    <div className="App">
      <IntroStateProvider introComplete={allowPageAnimations}>
        <BrowserRouter>
          <ScrollToTop/>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <IntroReveal
          active={showIntro}
          onSplitStart={handleIntroSplitStart}
          onComplete={handleIntroComplete}
        />
      </IntroStateProvider>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
